import { chat, clock, heart, help, shop, star } from "../assets";

export const routeNames = {
  login: "/auth/login",
  register: "/auth/register",
  dashboardHome: "/dashboard/home",
  details: "/dashboard/developer-details",
  buildings: "/dashboard/buildings",
  buildingDetails: "/dashboard/building-details",
  addBuilding: "/dashboard/add-building",
  guards: "/dashboard/guards",
  profile: "/dashboard/profile",
  management: "/dashboard/management",
  managementDetail: "/dashboard/management-detail",
  tenantsManagement: "/dashboard/tenants-management",
  tenantDetail: "/dashboard/tenant-detail",
};

export const card_items = [
  {
    id: 1,
    title: "Lorem, ipsum dolor.",
    detail: "Lorem ipsum dolor sit amet si consectetur elit.",
  },
  {
    id: 2,
    title: "Another title here.",
    detail: "Some other text goes here for this item.",
  },
  {
    id: 3,
    title: "Example title three.",
    detail: "Details about this third item go here for testing.",
  },
  {
    id: 4,
    title: "Fourth title example.",
    detail: "This is the detail text for the fourth example item.",
  },
];

export const menuItems = [
  {
    id: 1,
    label: "Home Screen",
    icon: "home",
    route: routeNames.dashboardHome,
  },
  {
    id: 2,
    label: "Developer Details",
    icon: "details",
    route: routeNames.details,
  },
  { id: 3, label: "Buildings", icon: "buildings", route: routeNames.buildings },
  { id: 4, label: "Guards", icon: "guards", route: routeNames.guards },
  { id: 5, label: "Profile", icon: "profile", route: routeNames.profile },
  {
    id: 6,
    label: "Management",
    icon: "management",
    route: routeNames.management,
  },
  {
    id: 7,
    label: "Tenants",
    icon: "tenants",
    route: routeNames.tenantsManagement,
  },
];

export const loginFields = [
  {
    type: "text",
    name: "username",
    placeholder: "Enter Username",
    required: true,
  },
  {
    type: "password",
    name: "password",
    placeholder: "Enter Password",
    required: true,
  },
];

export const roles = {
  superAdmin: "SuperAdmin",
  propertyOwner: "PropertyOwner",
};

export const vibrantColors = [
  "bg-gradient-to-r from-blue-400 to-blue-600 text-white",
  "bg-gradient-to-r from-green-400 to-green-600 text-white",
  "bg-gradient-to-r from-yellow-400 to-yellow-600 text-gray-800",
  "bg-gradient-to-r from-purple-400 to-purple-600 text-white",
  "bg-gradient-to-r from-pink-400 to-pink-600 text-white",
  "bg-gradient-to-r from-teal-400 to-teal-600 text-white",
  "bg-gradient-to-r from-red-400 to-red-600 text-white",
];
